import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * API Configuration Service
 */
@Injectable({
    providedIn: 'root'
})
export class ApiConfigService {
    private readonly baseUrl = `${environment.apiUrl}/api/v1`;

    getBaseUrl(): string {
        return this.baseUrl;
    }

    getApiUrl(endpoint: string): string {
        return `${this.baseUrl}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
    }

    getDefaultHeaders(): { [key: string]: string } {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
    }

    getAuthHeaders(token?: string): { [key: string]: string } {
        const headers = this.getDefaultHeaders();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        return headers;
    }
}
